import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { App, Spin, Result } from 'antd';
import { captureException } from '@sentry/react';
import useHttpClient from '/src/hooks/useHttpClient';
import { AuthContext } from '/src/constants/contexts';

function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const httpClient = useHttpClient();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
          throw new Error(error);
        }

        if (!code || !state) {
          throw new Error('Missing authorization code or state parameter');
        }

        // Send code and state to server for verification
        await httpClient.post('/auth/oauth2/callback', {
          code,
          state,
        });

        message.success('احراز هویت با موفقیت انجام شد');
        navigate('/', { replace: true });
      } catch (err) {
        captureException(err);
        console.error('OAuth callback error:', err);
        if (err.response?.data?.error === 'NO_CHANNEL_FOUND') {
          setError('هیچ کانالی به این حساب متصل نیست. لطفاً مطمئن شوید که حساب کاربری صحیح را انتخاب کرده‌اید.');
        } else {
          setError(err.message || 'خطا در احراز هویت');
        }
        message.error('خطا در احراز هویت، لطفا دوباره تلاش کنید');
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, httpClient, message, navigate]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
      >
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>در حال پردازش احراز هویت...</div>
      </div>
    );
  }

  if (error) {
    return (
      <Result
        status="error"
        title="خطا در احراز هویت"
        subTitle={error}
        extra={[
          <button
            key="retry"
            type="button"
            onClick={() => navigate('/settings')}
            style={{
              backgroundColor: '#ff0000',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            بازگشت به تنظیمات
          </button>,
        ]}
      />
    );
  }

  return null;
}

export default AuthCallback;
